import { render, staticRenderFns } from "./OrdersScheduleLaundryDeliveryExport.vue?vue&type=template&id=62842a70&scoped=true"
import script from "./OrdersScheduleLaundryDeliveryExport.vue?vue&type=script&lang=js"
export * from "./OrdersScheduleLaundryDeliveryExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62842a70",
  null
  
)

export default component.exports